import Dialog from '@mui/material/Dialog';
import { Box, Button, Typography, useTheme, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { FormButton } from 'theme/elements/Buttons';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectLanguage, selectTranslations } from 'state/reducers/translation.reducers';
import { getMobile } from 'state/reducers/ui.reducers';
import _ from 'lodash';
import { useMemo } from 'react';

type props = {
  open: boolean;
  handleContinue?: any;
  handleCancel?: any;
  title?: string;
  subTitle?: string | object;
  continueLabel?: string;
  cancelLabel?: string;
  closeLabel?: string;
  children?: any;
};

export default function WarningDialog(props: props) {
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const isMobile = useAppSelector(getMobile);
  const language = useAppSelector((state) => state.translation.language)
  const subtext = () => {
    if (_.isObject(props.subTitle)) {
      return (
        <Stack>
          {_.keys(props.subTitle).map((key) => {
            const title = t(key).includes('**') ? undefined : t(key)
            const subTitle = t(_.get(props.subTitle, key)).includes('**') ?
              t('validations.errors.' + _.get(props.subTitle, key)) : t(_.get(props.subTitle, key))
            //validations.errors.
            return <Stack direction="row" gap={1} sx={{ direction: 'ltr', justifyContent: 'center' }}>
              {title && <Typography variant="boldBody1">{title}: </Typography>}
              <Typography>{subTitle}</Typography>
            </Stack>
          })}
        </Stack>
      );
    }
    return props?.subTitle && !(t(props.subTitle)?.includes('**')) ? t(props.subTitle) : '';
  };
  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiPaper-root': {
          [theme.breakpoints.down('sm')]: {
            margin: '16px',
            maxWidth: '100%',
            width: '100%',
          },
        },
      }}
    >
      <Box sx={{ textAlign: 'center', padding: '12px 12px 36px 12px' }}>
        <Stack spacing={4}>
          <Box sx={{ height: '40px' }}>
            {isMobile && (
              <Box
                sx={{
                  background: theme.palette.root.darkGrayed_028,
                  width: '40px',
                  height: '40px',
                  textAlign: 'center',
                  float: 'right',
                  borderRadius: '8px',
                  cursor: 'pointer',
                }}
              >
                <CloseIcon
                  onClick={props.handleCancel}
                  sx={{ width: '20px', height: '40px', margin: 'auto' }}
                />
              </Box>
            )}
          </Box>
          <Box
            sx={{
              width: '56px',
              margin: 'auto!important',
              height: '56px',
              backgroundColor: '#ffa600',
              boxShadow: '0 2px 8px 0 rgba(255, 166, 0, 0.32)',
              borderRadius: '100%',
              textAlign: 'center',
            }}
          >
            <PriorityHighIcon sx={{ color: '#fff', height: '56px', width: '20px' }} />
          </Box>
          <Stack spacing={0} gap={1} sx={{ padding: '0 35px' }}>
            <Typography variant="h3" sx={{ direction: language === 'en' ? 'rtl' : 'ltr', [theme.breakpoints.up('sm')]: { padding: '0 60px' } }}>
              {t(props?.title || '', props?.title)}
            </Typography>
            <Typography variant="body3">{subtext()}</Typography>
            {props.children && props.children}
          </Stack>
          {props.handleContinue && (
            <Stack gap={2} direction="row" justifyContent="center">
              <FormButton>
                <Button variant="outlined" onClick={props.handleCancel}>
                  {props?.continueLabel}
                </Button>
              </FormButton>
              <FormButton>
                <Button variant="outlined" onClick={props.handleContinue} autoFocus>
                  {props?.cancelLabel}
                </Button>
              </FormButton>
            </Stack>
          )}
          {!props.handleContinue && (
            <FormButton>
              <Button variant="outlined" onClick={props.handleCancel}>
                {props?.closeLabel ? t(props?.closeLabel) : t('servers.errors.general.close_button.text')}
              </Button>
            </FormButton>
          )}
        </Stack>
      </Box>
    </Dialog>
  );
}
